import { ComponentType as ReactComponentType } from 'react';

import ComponentType from '../component-type';
import Constructor from '../util/constructor';

interface Provider {
  get: Function;
  accept: Function;
}

export interface ContainerProps {
  acceptedTypes?: ComponentType[];
  className?: string;
  onClick?: (event: MouseEvent) => void;
  repeated?: boolean;
  slot?: string;
  tag?: string;
  uuid: string;
}

class ContainerProvider {

  static providers: Provider[] = [];

  static register(type: Constructor, accept: (instance: object) => boolean): void {
    this.providers.push({
      get: () => type,
      accept,
    });
  }

  static provide(instance: object): ReactComponentType<ContainerProps> | null {

    for (let i = this.providers.length-1; i >= 0; i--) {
      const provider = this.providers[i];

      if (provider.accept(instance)) {
        return provider.get();
      }
    }

    return null;
  }

}

export default ContainerProvider;
